import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const WhatsAppInvoiceRoutes = defineRoute({
    record: {
        route: {
            path: "/whatsapp-invoice",
            component: () => loadView(import("./WhatsAppInvoiceTable.vue")),
        },
    },
    detail: {
        route: {
            path: "/whatsapp-invoice/detail/:id",
            component: () => loadView(import("./WhatsAppInvoiceDetail.vue")),
        },
        build(id: string) {
            return `/whatsapp-invoice/detail/${id}`;
        },
    },
});
